const CENTERED_FEATURE_SELECTOR = ".image-feature--centeredText";
const PENDING_CLASS = "image-feature--centeredText-pending";
const VISIBLE_CLASS = "image-feature--centeredText-visible";
const PARALLAX_SELECTOR = ".image-feature__media img";
const PARALLAX_RANGE = 18;

function syncParallax(feature) {
	const image = feature.querySelector(PARALLAX_SELECTOR);

	if (!image) {
		return;
	}

	const rect = feature.getBoundingClientRect();
	const viewportHeight = window.innerHeight || 1;
	const progress = (rect.top + rect.height / 2 - viewportHeight / 2) /
		(viewportHeight / 2 + rect.height / 2);
	const clamped = Math.max(-1, Math.min(1, progress));

	image.style.setProperty(
		"--image-feature-parallax-y",
		`${clamped * PARALLAX_RANGE}px`,
	);
}

function initCenteredFeatureReveal(features) {
	if (!("IntersectionObserver" in window)) {
		for (const feature of features) {
			feature.classList.add(VISIBLE_CLASS);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.2,
		},
	);

	for (const feature of features) {
		feature.classList.add(PENDING_CLASS);
		observer.observe(feature);
	}
}

function initCenteredFeatureParallax(features) {
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;

	if (prefersReducedMotion) {
		return;
	}

	let frameId = null;

	const scheduleSync = () => {
		if (frameId) {
			return;
		}

		frameId = window.requestAnimationFrame(() => {
			frameId = null;

			for (const feature of features) {
				syncParallax(feature);
			}
		});
	};

	window.addEventListener("scroll", scheduleSync, { passive: true });
	window.addEventListener("resize", scheduleSync, { passive: true });
	window.addEventListener("load", scheduleSync, { once: true });
	scheduleSync();
}

export function initImageFeatures() {
	const features = [...document.querySelectorAll(CENTERED_FEATURE_SELECTOR)];

	if (!features.length) {
		return;
	}

	initCenteredFeatureReveal(features);
	initCenteredFeatureParallax(features);
}
